import React from 'react';
import styles from './index.module.scss';
import CutoutCard from '../CutoutCard';
import { isEmpty } from 'lodash';
import FadeInSection from '../../wrapper/FadeInWrapper';
// import { useNavigateRoute } from '../../hooks/custom.hooks';

function OffersSectionRow({
  sectionName = 'Discount Offers',
  onClickViewAll = () => {},
  cardsData = [],
  onCardClick = () => {},
  sectionNameStyles = {},
  showClaim = false,
  onClaim = () => {},
}) {
  // const navigateRoute = useNavigateRoute();
  if (isEmpty(cardsData)) return null;
  return (
    <FadeInSection>
      <div className={styles.offerSectionRow}>
        <div className={styles.headerRow}>
          <div className={styles.sectionName} style={sectionNameStyles}>
            {sectionName}
          </div>
          <div className={styles.viewAllBtn} onClick={onClickViewAll}>
            View All
          </div>
        </div>
        <div className={styles.dataScrollRow}>
          {cardsData.map((entry, key) => (
            <CutoutCard
              card={entry}
              key={key}
              onCardClick={onCardClick}
              showClaim={showClaim}
              onClaim={onClaim}
            />
          ))}
        </div>
      </div>
    </FadeInSection>
  );
}

export default React.memo(OffersSectionRow);
